module.exports = __webpack_public_path__ + "ff53e31e75cec16a55fc86f64a552fe4.jpg";